module.exports = __webpack_public_path__ + "static/SZITCH2-50731e7ad69c9d4470842110fbe9b561.jpg";